// Inspector — the editor for whatever the ledger has selected. Desktop mounts
// it in the sticky right column, mobile inside the bottom sheet; the same
// tree renders in both.

import { useLedger } from '../../lib/ledger-state';
import { isFoodSlot } from '../../lib/ledger';
import { CoachInspector } from './CoachInspector';
import { DayInspector } from './DayInspector';
import { MealInspector } from './MealInspector';
import { SessionInspector } from './SessionInspector';
import { WeightInspector } from './WeightInspector';

export function Inspector() {
  const { date, row, coach } = useLedger();
  if (coach) return <CoachInspector />;
  if (isFoodSlot(row)) return <MealInspector date={date} slot={row} />;
  if (row === 'day') return <DayInspector date={date} />;
  if (row === 'session') return <SessionInspector date={date} />;
  return <WeightInspector date={date} />;
}
